const LOCALS = {
  EN: "en",
  RU: "ru",
};

export { LOCALS };
